import { Base } from '@studiometa/js-toolkit';

/**
 *
 */
export default class Search extends Base {
  static config = {
    name: 'Search',
    refs: ['iconSearch', 'formSearch', 'inputSearch'],
  };

  /**
   *
   */
  mounted() {
    this.$refs.iconSearch;
    this.$refs.formSearch;
    this.$refs.inputSearch;
    console.log(this.$refs.formSearch);
  }

  /**
   *
   */
  onIconSearchClick() {
    this.$refs.formSearch.classList.remove('hidden');
    this.$refs.formSearch.classList.toggle('flex');
    setTimeout(() => {
      this.$refs.formSearch.classList.toggle('translate-y-0');
      this.$refs.inputSearch.focus();
    }, 1);
  }

  /**
   *
   */
  onDocumentClick(event) {
    const searchForm = this.$refs.formSearch;
    const isClickInsideSearch = searchForm.contains(event.target);
    const isFormVisible = searchForm.classList.contains('translate-y-0');
    if (!isClickInsideSearch && isFormVisible) {
      searchForm.classList.remove('translate-y-0');
      setTimeout(() => {
        searchForm.classList.remove('flex');
        searchForm.classList.toggle('hidden');
      }, 501);
    }
  }
}
